@import '~style-sheet-helpers/core.less';
@import '../../../../../app-brand/entities/entity-layer.module.less';

.container {
  padding-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .select-container {
    display: flex;
    flex-direction: column;
    gap: 5px;
    font-size: 14px;

    .select-label {
      color: @order-details--order-templates--text-color;
      font-size: 13px;
      font-weight: @bold;
    }

    .select-dropdown-menu {
      width: 100%;
    }
  }
}
